export default {
	lookup: (x, y, cb) => cb(null, []),
	resolveSrv: (x, cb) => cb(null, []),
};
